import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import catalog from '../data/labs.json';
const { pageSeo, structuredData } = require('../utils/seo');
function meta(attribute, key, content) {
  const elements = Array.from(document.head.querySelectorAll(`meta[${attribute}="${key}"]`));
  const element = elements.shift() || document.createElement('meta');
  elements.forEach(duplicate => duplicate.remove());
  element.setAttribute(attribute, key); element.content = content; document.head.appendChild(element);
}
export default function RouteSeo() {
  const { pathname } = useLocation();
  useEffect(() => {
    const seo = pageSeo(pathname, catalog.labs);
    document.title = seo.title;
    meta('name', 'description', seo.description);
    meta('name', 'robots', seo.robots);
    meta('property', 'og:title', seo.title);
    meta('property', 'og:description', seo.description);
    meta('property', 'og:url', seo.canonical || '');
    meta('name', 'twitter:title', seo.title);
    meta('name', 'twitter:description', seo.description);
    document.head.querySelectorAll('link[rel="canonical"]').forEach(element => element.remove());
    if (seo.canonical) { const element = document.createElement('link'); element.rel = 'canonical'; element.href = seo.canonical; document.head.appendChild(element); }
    document.head.querySelectorAll('script[type="application/ld+json"]').forEach(element => element.remove());
    const data = structuredData(seo, catalog.labs);
    if (data) { const element = document.createElement('script'); element.type = 'application/ld+json'; element.textContent = JSON.stringify(data); document.head.appendChild(element); }
  }, [pathname]);
  return null;
}
